import React from "react";
import { Modal } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleModalProps extends React.ComponentProps<typeof Modal> {
  useEditorTheme?: boolean;
}

const TrebbleModal = ({ useEditorTheme, ...restProps }: TrebbleModalProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  // Note: Ant Design's Modal uses static methods (Modal.info, etc.) which won't automatically use the theme.
  // The theme is applied when Modal is used as a component like <TrebbleModal ... />.
  // If you need themed static methods, a different approach would be required.

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Modal {...restProps} />
    </TrebbleConfigProvider>
  );
};

export default TrebbleModal; 